import { FieldArray, useFormikContext } from "formik"
import React, { Fragment } from "react"
import { FIELD_TYPES } from "../dynamic-form.constants"
import { GetFormElements, getInNested } from "../dynamic-form.helper"

function FieldList(props) {
  const { id, name, errorMessage, field_list, field_list_schema, fieldData, ...otherProps } = props
  // Grab values and submitForm from context
  const { values, errors, touched, submitCount } = useFormikContext()
  const groupError = getInNested(errors, name, false)
  // Gate the group-level error so it only appears after interaction / attempted
  // advance — not on first render (matches field-level touch gating).
  const groupErrorTouched = !!getInNested(touched, name, false) || submitCount > 0
  const groupErrorMessage = groupErrorTouched && groupError && typeof groupError === "string" ? groupError : ""
  return (
    <FieldArray
      id={id}
      name={name}
      render={(arrayHelpers) => (
        <div className="col-12 custom-form-block d-flex flex-column">
          <Fragment>
            {values[name] && Array.isArray(values[name]) && (
              <Fragment>
                {values[name].map((field, value_index) => (
                  <Fragment key={`field-${value_index}`}>
                    {fieldData &&
                      Array.isArray(fieldData) &&
                      fieldData.map((field, field_index) => (
                        <Fragment key={`key-${field.id}-${field_index}`}>
                          {field.type !== FIELD_TYPES.ACTION_BTN ? (
                            <div className={`col-${field.width}`}>
                              {GetFormElements(
                                field,
                                `${name}[${value_index}]['${field.name}']`,
                                errors,
                                null, // timezones
                                true // use dot notation in field name
                              )}
                            </div>
                          ) : (
                            <div className={`col-${field.width}`}>
                              <div className="d-flex align-items-center pt-2 h-100">
                                <span className="icon-wrapper clickable" onClick={() => arrayHelpers.remove(value_index)}>
                                  <i className="fa-solid fa-trash-can"></i>
                                </span>
                              </div>
                            </div>
                          )}
                        </Fragment>
                      ))}
                  </Fragment>
                ))}
                <div className={`col-4`}>
                  <div className="d-flex align-items-center pt-2 pb-3 h-100">
                    <button type="button" className="btn btn-primary" onClick={() => arrayHelpers.push(field_list_schema)}>
                      <span className="icon-wrapper me-2">
                        <i className={`fa-solid fa-add`}></i>
                      </span>
                      Add
                    </button>
                  </div>
                </div>
              </Fragment>
            )}
          </Fragment>
          <div className="invalid-feedback">{groupErrorMessage}</div>
        </div>
      )}
    ></FieldArray>
  )
}

FieldList.propTypes = {}

export default FieldList
